import React from 'react';
import { LinearProgress } from '@material-ui/core';

export const Loading: React.FC = () => {
  return (
    <div>
      <br />
      <h2> Cargando... </h2>
      <LinearProgress />
    </div>
  );
};